import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { Title } from 'components/misc'
import { VideoCMS } from 'components/video-cms'
import { Section } from './styled'

export const Horses = forwardRef<HTMLDivElement, {}>((_, ref) => (
  <Section ref={ref}>
    <TextContainer>
      <Title data-menu-title="песня коню">Кони в культуре бурят</Title>
      <p>
      Конь (морин) в бурятской культуре считается драгоценным животным, центром мироздания, исключительным существом, с которым неразрывно связаны обряды и традиции жизни кочевников. Все вещи, связанные с лошадьми, играли особенную роль. Например, коновязь (сэргэ) – олицетворение крепости рода – уничтожали, если род прерывался. Изображение лошади считалось священным, приносящим в дом удачу. Буряты верили, что лошадь может говорить с человеком на одном языке. После трудного и тяжелого пути бурят пел своему коню песню, в которой были обязательно слова благодарности. "Песня коню" до сих пор у бурят считается особенной. Авторства у нее нет, потому что каждый кочевник сочинял свою песню коню, подбирая особенные слова почтения и уважения.
      </p>

      <VideoCMS
        poster="https://gdb.currenttime.tv/01000000-c0a8-0242-a4d1-08dc1dfa1c64_w738.png"
        localhost={'https://currenttime.tv'}
        id="32791690"
      />
    </TextContainer>
  </Section>
))
